module.exports = __webpack_public_path__ + "img/cj-draw-card.90f48c40.png";